import React from 'react';

import { ToastContainer, Route, Routes, Navigate } from './Data/Imports';
import 'react-toastify/dist/ReactToastify.css';

// Pages
import Layout from './Pages/Layout';
import Home from './Pages/Home';
import AddProducts from './Pages/AddProducts';
import ProductList from './Pages/ProductList';

// Management
import ReadLogs from './applicationManagement/Pages/ReadLogs';
import AddLabel from './applicationManagement/Components/Labels/AddLabel';
import ManageLabels from './applicationManagement/Components/Labels/ManageLabels';
import ManagementLayout from './applicationManagement/Pages/ManagementLayout';
import { ProtectedRoute } from './Auth/ProtectedRoute';
import Login from './applicationManagement/Pages/Login';

const App = () => {
	return (
		<>
			<Routes>
				<Route path='/' element={<Navigate to='/dashboard' />} />
				{/* Main Routes */}
				<Route element={<Layout />}>
					<Route path='/dashboard' index element={<Home />} />
					<Route path='/add-product' element={<AddProducts />} />
					<Route path='/product-list' element={<ProductList />} />
				</Route>

				{/* Application Management Routes with path prefix */}

				<Route
					element={
						<ProtectedRoute>
							<ManagementLayout />
						</ProtectedRoute>
					}>
					<Route path='/read-logs' index element={<ReadLogs />} />
					<Route path='/add-label' element={<AddLabel />} />
					<Route path='/manage-labels' element={<ManageLabels />} />
				</Route>
				<Route path='/applicationManagement/login' element={<Login />} />
			</Routes>

			<ToastContainer
				position='top-right'
				autoClose={1000}
				hideProgressBar={true}
				closeOnClick
				pauseOnHover
				draggable
				pauseOnFocusLoss
				className='mt-10'
			/>
		</>
	);
};

export default App;
